import { CampaignType_Enum as CampaignType } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { FeatureAccessPermissions } from '@frontend/feature-access';

type UseOrgLevelLocationSelectorReturn = {
  permission: Permission;
};

/**
 * Central place for the org-level location selector: derives the ACL permission for the campaign's
 * channel (undefined campaignType = email), which scopes the picker's selectable locations.
 */
export const useOrgLevelLocationSelector = (campaignType?: CampaignType): UseOrgLevelLocationSelectorReturn => {
  return {
    permission:
      campaignType === CampaignType.SMS
        ? FeatureAccessPermissions.bulkTexting
        : FeatureAccessPermissions.emailMarketing,
  };
};
